import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import Icon from '../Icon/Icon';

const HeaderMegaMenuMenuItem = ({
  children,
  href,
  onClick,
  targetBlank,
  ...rest
}) => <li className="c-header-nav__item">
    <Button
      color="subtle"
      href={href}
      onClick={onClick}
      className="c-header-nav__link"
      {...(targetBlank ? { target: '_blank' } : {})}
      {...rest}
    >
      {children}
      <Icon
        icon="arrow-right"
        className="c-header-nav__icon  c-header-nav__icon--right  c-header-nav__icon--tiny  u-show@desktop"
      />
    </Button>
  </li>

export default HeaderMegaMenuMenuItem;

HeaderMegaMenuMenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  targetBlank: PropTypes.bool,
};

HeaderMegaMenuMenuItem.defaultProps = {
  href: '',
  onClick: () => {},
  targetBlank: false,
};
